import { Helmet } from 'react-helmet';
import AnalyticsPackage from 'src/features/AnalyticsPackage';

const AnalyticsPackagePage = () => {
  return (
    <>
      <Helmet>
        <title>Analytics Package</title>
      </Helmet>
      <AnalyticsPackage />
    </>
  );
};

export default AnalyticsPackagePage;
